import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Container, Textarea, TextInput, Select } from 'react-materialize';
import Button from '../atoms/button.jsx';
import { Label } from '../atoms/label.jsx';
import Row from '../organism/row.jsx';
import { COLOR, SIZE, KEY, LABEL, SCREEN_MEDIA, FONT_FAMILY } from '../../utils/constants.js';
import { useDecorationTypes } from '../hooks/useDecorationTypes';
import LoadingSpinner from '../organism/spinner';
import { useDecorationPost } from '../hooks/useDecorationPost.js';

const BodyDecorationPost = () => {

    const { data: typeList, isLoading } = useDecorationTypes();

    const typeCatLv1List = useMemo(() => {
        return typeList ? typeList.categoriesLv1 : [];
    }, [typeList]);

    const typeGenreList = useMemo(() => {
        return typeList ? typeList.genres : [];
    }, [typeList]);
    
    const typeThemLv1List = useMemo(() => {
        return typeList ? typeList.thematicsLv1 : [];
    }, [typeList])
    
    const typeThemLv2List = useMemo(() => {
        return typeList ? typeList.thematicsLv2 : [];
    }, [typeList])

    const typeThemLv3List = useMemo(() => {
        return typeList ? typeList.thematicsLv3 : [];
    }, [typeList])

    const [typeCatLv2List, setTypeCatLv2List] = useState([])
    const [typeThemLv2FilteredList, setTypeThemLv2FilteredList] = useState([])
    const [typeThemLv3FilteredList, setTypeThemLv3FilteredList] = useState([])

    const [isFormLoading, setIsFormLoading] = useState(false)
    const [formData, setFormData] = useState(null);

    const decorationPostResult = useDecorationPost(isFormLoading, formData)

    useEffect(() => {
        if (decorationPostResult && decorationPostResult?.success !== undefined) {
            setIsFormLoading(false)
            if (decorationPostResult.success) {
                window.M.toast({
                    html: 'Upload successful!',
                    classes: 'rounded green',
                    displayLength: 3000
                })
            } else {
                window.M.toast({
                    html: 'Upload error!',
                    classes: 'red',
                    displayLength: 3000
                })
            }
        }
    }, [decorationPostResult])

    const onCatalogLv1Selected = (e) => {
        e.preventDefault();
        let catLv1Id = e.target.value
        let catLv1Filtered = typeCatLv1List.find(obj => obj.id.toString() === catLv1Id)
        setTypeCatLv2List(catLv1Filtered.categoryLv2)
    }

    const onThematicLv1Selected = (e) => {
        e.preventDefault();
        let themLv1Id = e.target.value
        let themLv2Filtered = typeThemLv2List.filter((item, index) => {
            return item.parentId && item.parentId.toString() === themLv1Id
        })

        let themLv3Filtered = typeThemLv3List.filter((item, index) => {
            if (themLv1Id === '0') {
                return !item.parentLv1Id
            } else {
                return item.parentLv1Id && item.parentLv1Id.toString() === themLv1Id
            }
        })
        setTypeThemLv2FilteredList(themLv2Filtered)
        setTypeThemLv3FilteredList(themLv3Filtered)
    }

    const onThematicLv2Selected = (e) => {
        e.preventDefault();
        let themLv2Id = e.target.value
        let themLv3Filtered = typeThemLv3FilteredList.filter((item, index) => {
            return item.parentLv2Id && item.parentLv2Id.toString() === themLv2Id
        })
        setTypeThemLv3FilteredList(themLv3Filtered)
    }

    const handleDecorationPost = (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget)
        if (data.get('themlv1') === '0') {
            data.delete('themlv1')
        }
        setFormData(data);
        setIsFormLoading(true)
    }

    if (isLoading || isFormLoading) return <LoadingSpinner/>

    return(
        <Container>
            <Row>
                <form onSubmit={ handleDecorationPost }>
                <TextInput
                    label='Upload WebP'
                    type='file'
                    name='image'
                    accept="image/webp, image/jpeg, image/png" // Limits selection to WebP
                    onChange={ () => {} }
                    />
                <Select
                    id={`score`}
                    name={`score`}
                    multiple={false}
                    onChange={ () => {} }
                    options={{
                        dropdownOptions: {
                        closeOnClick: true,
                        }
                    }}>
                    <option value='' disabled selected>{`Score`}</option>
                    {/* Generate 0 to 20 on the fly and map them to elements */}
                    {
                        Array.from({ length: 21 }, (v, i) => (
                            <option key={i} value={i*5}>
                                {(i*5)/10}
                            </option>
                        ))
                    }
                </Select>
                {
                    (typeCatLv1List && typeCatLv1List.length > 0) &&
                    <Select
                        id={`catLv1`}
                        name={`catLv1`}
                        multiple={false}
                        onChange={ onCatalogLv1Selected }
                        >
                        <option value='' disabled selected>{`Type Category Lv1`}</option>
                        {
                            typeCatLv1List.map((item, index) =>
                                <option value={item.uuid}>
                                    { item.title }
                                </option>
                            )
                        }
                    </Select>
                }
                {
                    (typeCatLv2List && typeCatLv2List.length > 0) &&
                    <Select
                        id={`catLv2`}
                        name={`catLv2`}
                        multiple={false}
                        >
                        <option value='' disabled selected>{`Type Category Lv2`}</option>
                        {
                            typeCatLv2List.map((item, index) =>
                                <option value={item.uuid}>
                                    { item.title }
                                </option>
                            )
                        }
                    </Select>
                }
                {
                    (typeGenreList && typeGenreList.length > 0) &&
                    <Select
                        id={`genre`}
                        name={`genre`}
                        multiple={false}
                        >
                        <option value='' disabled selected>{`Type Genre`}</option>
                        {
                            typeGenreList.map((item, index) =>
                                <option value={item.uuid}>
                                    { item.title }
                                </option>
                            )
                        }
                    </Select>
                }
                <Select
                    id={`themlv1`}
                    name={`themlv1`}
                    multiple={false}
                    onChange={ onThematicLv1Selected }
                    >
                    <option value='' disabled selected>{`Type Thematic Lv1`}</option>
                    {
                        typeThemLv1List.map((item, index) =>
                            <option value={item.uuid}>
                                { item.title }
                            </option>
                        )
                    }
                    <option value={0}>{`Ninguno`}</option>
                </Select>
                {
                    (typeThemLv2FilteredList && typeThemLv2FilteredList.length > 0) &&
                    <Select
                        id={`themlv2`}
                        name={`themlv2`}
                        multiple={false}
                        onChange={ onThematicLv2Selected }
                        >
                        <option value='' disabled selected>{`Type Thematic Lv2`}</option>
                        {
                            typeThemLv2FilteredList.map((item, index) =>
                                <option value={item.uuid}>
                                    { item.title }
                                </option>
                            )
                        }
                    </Select>
                }
                {
                    (typeThemLv3FilteredList && typeThemLv3FilteredList.length > 0) &&
                    <Select
                        id={`themlv3`}
                        name={`themlv3`}
                        multiple={false}
                        onChange={{}}
                        >
                        <option value='' disabled selected>{`Type Thematic Lv3`}</option>
                        {
                            typeThemLv3FilteredList.map((item, index) =>
                                <option value={item.uuid}>
                                    { item.title }
                                </option>
                            )
                        }
                    </Select>
                }
                <TextInput
                    id="videoUrl"
                    name="videoUrl"
                    placeholder="Video URL"
                    />
                <Textarea
                    id="description"
                    name="description"
                    placeholder="Description"
                    />
                <Button
                    type='submit'
                    width='120px'
                    height='46px'
                    bg_color={ COLOR.black }
                    margin='10px 0 0 0'
                    float='right'
                    onChange={ () => {} }>
                    <Label
                        text_color={ COLOR.white }
                        text_size={SIZE.subtitle}
                        font_family={FONT_FAMILY.avenirMedium}
                        margin='auto'>
                        {LABEL.send}
                    </Label>
                </Button>
                </form>
            </Row>
        </Container>
    )
};

export default BodyDecorationPost;